if (!customElements.get('damagemod-release-card')) {
  customElements.define('damagemod-release-card', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.storageKey = 'damagemod-release-v1-dismissed-until';
      this.closeButton = this.querySelector('[data-dm-close]');
      this.exploreLink = this.querySelector('[data-dm-explore]');
      this.closeButton?.addEventListener('click', () => {
        this.rememberDismissal();
        this.hidden = true;
      });
      this.exploreLink?.addEventListener('click', () => {
        this.rememberDismissal();
        this.hidden = true;
      });
      this.onKeyDown = (event) => {
        if (event.key === 'Escape' && this.contains(document.activeElement)) {
          this.rememberDismissal();
          this.hidden = true;
        }
      };
      this.addEventListener('keydown', this.onKeyDown);
      let dismissedUntil = 0;
      try { dismissedUntil = Number(localStorage.getItem(this.storageKey)) || 0; }
      catch {
        try { dismissedUntil = Number(sessionStorage.getItem(this.storageKey)) || 0; }
        catch {}
      }
      if (dismissedUntil > Date.now() && !window.Shopify?.designMode) return;
      this.timer = window.setTimeout(() => { this.hidden = false; }, Number(this.dataset.delay) || 0);
    }
    rememberDismissal() {
      const until = String(Date.now() + 14 * 24 * 60 * 60 * 1000);
      try { localStorage.setItem(this.storageKey, until); }
      catch { try { sessionStorage.setItem(this.storageKey, until); } catch {} }
    }
    disconnectedCallback() {
      window.clearTimeout(this.timer);
      this.removeEventListener('keydown', this.onKeyDown);
      this.initialized = false;
    }
  });
}
